import React, { useEffect, useState } from "react";
import { collection, query, where, orderBy, limit, onSnapshot } from "firebase/firestore";
import Context from "../../../../Context";
import constant from "../../../../constants";
import { ScrollArea } from "../../../../components/ui";
import { getStatusBgClass } from "../utils";
import { FaPlus } from "react-icons/fa";

export const OrderHistory = ({ order }) => {
  const { configs, db } = Context();
  const [roundDate, setRoundDate] = useState(configs?.roundDate || "");
  const [orders, setOrders] = useState(null);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    if (!roundDate && configs?.roundDate) setRoundDate(configs.roundDate);
  }, [roundDate, configs?.roundDate]);

  useEffect(() => {
    setOrders(null);
    setLoadError(false);
    if (!order?.userId || !roundDate || !db) return;

    return onSnapshot(
      query(
        collection(db, "Orders"),
        where("userId", "==", order.userId),
        where("roundDate", "==", roundDate),
        orderBy("createdAt", "desc"),
        limit(250)
      ),
      (snapshot) => {
        setLoadError(false);
        setOrders(snapshot.docs.map((item) => ({ ...item.data(), id: item.id })));
      },
      (error) => {
        console.error("OrderHistory subscription error:", error);
        setLoadError(true);
        setOrders([]);
      }
    );
  }, [db, roundDate, order?.userId]);

  return (
    <div className="relative bg-white w-full rounded-md shadow-xs border border-slate-200 overflow-hidden">
      <div className="flex items-center justify-between p-3.5 border-b border-slate-200 bg-slate-50/60">
        <h3 className="font-bold text-base text-slate-800">
          คำสั่งซื้ออื่นๆ ในงวด
        </h3>
        <div className="flex items-center gap-2">
          <select
            className="border border-slate-300 text-slate-800 text-xs py-1.5 px-2.5 font-bold rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-500/20"
            value={roundDate}
            onChange={(e) => setRoundDate(e.target.value)}
          >
            {(configs?.roundDates || []).map((rd) => (
              <option key={rd} value={rd}>
                {rd}
              </option>
            ))}
          </select>
          <button
            type="button"
            className="bg-blue hover:opacity-90 text-white p-2 rounded-md font-bold text-xs transition-all shadow-xs cursor-pointer"
            onClick={() =>
              order?.userId &&
              window.open(`/orders/create/${order.userId}`, "_blank")
            }
            title="สร้างคำสั่งซื้อใหม่"
          >
            <FaPlus />
          </button>
        </div>
      </div>

      <ScrollArea className="h-[320px] p-3">
        {loadError ? (
          <p role="alert" className="p-3 text-sm text-rose-600">
            ไม่สามารถรับข้อมูลคำสั่งซื้อแบบ realtime ได้ กรุณาเปิดหน้านี้ใหม่
          </p>
        ) : orders === null ? (
          <div className="w-full min-h-60 flex justify-center items-center">
            <div className="w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
          </div>
        ) : orders.length === 0 ? (
          <div className="h-60 w-full flex justify-center items-center text-slate-400 font-semibold text-sm">
            <p>ไม่พบข้อมูลคำสั่งซื้อในงวดนี้</p>
          </div>
        ) : (
          <div className="flex flex-col gap-2">
            {orders.map((o) => (
              <div
                key={o.id || o.shortId}
                onClick={() => window.open(`/orders/${o.id}`, "_blank")}
                className={`${getStatusBgClass(
                  o.status
                )} grid grid-cols-4 gap-2 border border-slate-300/30 p-2.5 rounded-md cursor-pointer hover:opacity-95 hover:shadow-sm transition-all text-xs font-semibold`}
              >
                <div>
                  <p className="opacity-80 text-[11px]">รหัสสั่งซื้อ</p>
                  <p className="font-bold text-sm truncate">{o.shortId || o.id?.slice(-5)}</p>
                </div>
                <div>
                  <p className="opacity-80 text-[11px]">จำนวนใบ</p>
                  <p className="font-bold text-sm">{o.size || 0}</p>
                </div>
                <div>
                  <p className="opacity-80 text-[11px]">ราคา</p>
                  <p className="font-bold text-sm">
                    {o.totalPrice ? Number(o.totalPrice).toLocaleString() : 0}
                  </p>
                </div>
                <div>
                  <p className="opacity-80 text-[11px]">สถานะ</p>
                  <p className="font-bold text-sm">
                    {constant.statusesTranslate[o.status] || o.status}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </ScrollArea>
    </div>
  );
};
